import { HttpInterceptorFn, HttpContextToken, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, from, switchMap, take, throwError } from 'rxjs';
import { FsxB2CDocumentDiscoveryURL } from '../auth/config/auth.config';

export const BYPASS_TOKEN_INJECTION = new HttpContextToken(() => false);

export const fsxInterceptor: HttpInterceptorFn = (req, next) => {
  const oAuthService = inject(OAuthService);
  const authToken = oAuthService.getAccessToken() ?? null;

  if (!req.context.get(BYPASS_TOKEN_INJECTION)) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${authToken}`),
    });
  }

  return next(req).pipe(
    catchError((httpError: HttpErrorResponse) => {
      if (httpError.status === 401) {
        return from(oAuthService.loadDiscoveryDocument(FsxB2CDocumentDiscoveryURL)).pipe(
          switchMap(() => next(req)),
          take(1)
        );
      }
      return throwError(() => httpError);
    })
  );
};
